import { inject, Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';

import { SpecificationState, SpecificationStore } from './specification.store';

@Injectable({ providedIn: 'root' })
export class SpecificationQuery extends QueryEntity<SpecificationState> {
  protected store: SpecificationStore;

  constructor() {
    const store = inject(SpecificationStore);

    super(store);

    this.store = store;
  }
}
